import { featuredCollections } from '@/mocks/home';
import SectionHeading from '@/components/base/SectionHeading';

export default function FeaturedCollections() {
  return (
    <section id="collections" className="w-full scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <SectionHeading
          eyebrow="资源合集"
          title="精选合集 · 大图卡片流"
          desc="每个合集都是一个完整的浏览单元，封面克制、标题优先，点进去就能看到按维度整理好的清单。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {featuredCollections.map((item) => (
            <a
              key={item.title}
              href="#summary"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 黑料总站资源合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/95 px-3 py-1 font-label text-[11px] text-foreground-800 backdrop-blur-sm">
                  {item.tag}
                </span>
                <span className="absolute bottom-4 right-4 rounded-full bg-foreground-950/85 px-3 py-1 font-label text-[11px] text-background-50 backdrop-blur-sm">
                  {item.count} 条索引
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between gap-3">
                  <h4 className="font-heading text-lg font-bold text-foreground-950">
                    {item.title}
                  </h4>
                  <span className="flex shrink-0 items-center gap-1 font-label text-[11px] text-foreground-500">
                    <i className="ri-time-line" />
                    {item.updated}
                  </span>
                </div>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
                <span className="mt-5 flex items-center gap-1.5 font-label text-[13px] text-primary-700">
                  浏览合集
                  <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}